import RouteList from '@/controllers/route/route-list.js';

export default {
  extends: RouteList,
};
